import { Box } from '../Box/Box.js';
import styled from 'styled-components';

var ListContainer = /*#__PURE__*/styled(Box).withConfig({
  displayName: "TooltipListstyled__ListContainer",
  componentId: "sc-wwfo2v-0"
})(function (props) {
  return {
    columnCount: props.$columnCount,
    columnGap: props.$columnGap,
    rowGap: props.$rowGap
  };
});

export { ListContainer };
//# sourceMappingURL=TooltipList.styled.js.map
